import { Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"

interface EmptyMobileAdvertisementProps {
  additionalStyling?: object
}

export default function EmptyMobileAdvertisement({
  additionalStyling,
}: EmptyMobileAdvertisementProps) {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        alignContent: "center",
        justifyContent: "center",
        overflow: "hidden",
        backgroundColor: "#B0B8C1",
        ...additionalStyling,
      }}
      onClick={() => {
        navigate("/about-us")
      }}
    >
      <Box
        sx={{
          display: "flex",
          paddingY: 2,
          justifyContent: "center",
          alignContest: "center",
          borderTopRightRadius: "8px",
          borderTopLeftRadius: "8px",
        }}
      >
        <Typography textAlign="center">
          Contact us to host your own advertisement here!
        </Typography>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "30%", // Adjust as needed
          borderTopRightRadius: "8px",
          borderTopLeftRadius: "8px",
          background:
            "linear-gradient(to bottom, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0))",
        }}
      />
      {/* </a> */}
    </Box>
  )
}
